function initLazyScript(element, callback, threshold = 500) {
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof callback === 'function') {
            callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: `0px 0px ${threshold}px 0px` });

    io.observe(element);
  } else {
    callback();
  }
}

window.initLazyScript = initLazyScript;

if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // ✅ query scoped (fix multi instance)
      this.minNumberInput = this.querySelector('#price-range-number-min');
      this.maxNumberInput = this.querySelector('#price-range-number-max');
      this.minSliderInput = this.querySelector('#price-range-slider-min');
      this.maxSliderInput = this.querySelector('#price-range-slider-max');
      this.progress = this.querySelector('.price-filter__progress');

      // ✅ range
      this.rangeMin = Number(this.minSliderInput.min);
      this.rangeMax = Number(this.maxSliderInput.max);

      this.timeout = null;

      this.addEventListener('input', this.handleInput.bind(this));
      this.handleEnterSubmit();

      // init UI
      this.updateProgress();
    }

    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
          this.updateProgress();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
        this.updateProgress();
      }
    }

    handleEnterSubmit() {
      [this.minNumberInput, this.maxNumberInput].forEach((input) => {
        input.addEventListener('keyup', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();

            // cập nhật lại slider + progress trước
            this.updateSliderInputs(e);
            this.updateNumberInputs();
            this.updateProgress();

            // mất focus
            input.blur();
            // trigger submit filter (Shopify)
            const form = this.closest('form');
            if (form) {
              form.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        });
      });
    }

    updateNumberInputs() {
      this.minNumberInput.value =
        this.minSliderInput.value != this.rangeMin
          ? this.minSliderInput.value
          : '';

      this.maxNumberInput.value =
        this.maxSliderInput.value != this.rangeMax
          ? this.maxSliderInput.value
          : '';
    }

    updateSliderInputs(evt) {
      let min = parseInt(this.minNumberInput.value, 10);
      let max = parseInt(this.maxNumberInput.value, 10);

      min = isNaN(min) ? this.rangeMin : min;
      max = isNaN(max) ? this.rangeMax : max;

      // enforce gap
      if (min > max - 10) {
        if (evt.target === this.minNumberInput) {
          max = min + 10;
          if (max > this.rangeMax) {
            min = this.rangeMax - 10;
            max = this.rangeMax;
          }
        } else {
          min = max - 10;
        }
      }

      if (max < min + 10) {
        if (evt.target === this.maxNumberInput) {
          min = max - 10;
          if (min < this.rangeMin) {
            min = this.rangeMin;
            max = this.rangeMin + 10;
          }
        } else {
          max = min + 10;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = min;
      }

      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = max;
      }

      if (evt.target === this.minSliderInput) {
        this.minNumberInput.value = min;
      }

      if (evt.target === this.maxSliderInput) {
        this.maxNumberInput.value = max;
      }
    }

    updateProgress() {
      const min = Number(this.minSliderInput.value);
      const max = Number(this.maxSliderInput.value);

      const minPercent =
        ((min - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;

      const maxPercent =
        ((max - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;

      this.progress.style.left = `${minPercent}%`;
      this.progress.style.right = `${100 - maxPercent}%`;
    }
  }

  customElements.define('price-range', PriceRange);
}
